/* global React */
// eslint-disable-next-line object-curly-newline
import { useCallback, useMemo } from 'react'
import { ImageListItemBar, ImageListItem, IconButton } from '@mui/material'
import { useMemoRef, useStyles, useAttachmentAPI } from '@platform/react/hook'
import Icon from 'ui/Element/Icon'

const styles = theme => ({
  tile: {
    display: 'flex',
    flexBasis: '22%',
    // height: 'auto',
    minHeight: '9.375rem',
    minWidth: '9.375rem',
    maxHeight: '11.25rem',
    marginBottom: '1%',
  },
  actionIcon: {
    display: 'flex',
  },
  icon: {
    color: '#fff',
  },
  ...theme.custom.attachmentListTemplateGeneric,
})

/**
 * Attachment List Template Generic
 *
 * @param {Object} attachment the attachment to download
 * @param {string} [group]    attachment group
 * @param {Object} props      additional props
 * @returns {JSX.Element}
 */
const AttachmentListTemplateGeneric = ({ attachment, group, ...props }) => {
  const { value: item } = attachment
  const classes = useStyles(styles)()
  const { state, onLoad } = useAttachmentAPI({ attachment, group })
  const { src, progress } = state

  const onClick = useCallback(props.events.onClick(attachment), [attachment])

  const sanitizedName = useMemo(() => decodeURIComponent(item.name), [item.name])

  const onMore = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    console.log('onMore')
  }, [attachment])

  // here we are going to use whatever ui element / component to display image / type icons
  // embed could be used instead of img to display pdf preview,
  // embedded doc HAS to be detached on destruction
  return (
    <ImageListItem
      onClick={onClick}
      // cols={1}
      className={classes.tile}
    >
      <img
        src={src}
        alt={sanitizedName}
        onLoad={onLoad}
        style={{
          width: '100%',
          height: 'auto',
        }}
      />
      <ImageListItemBar
        title={sanitizedName}
        /* eslint-disable-next-line no-plusplus */
        subtitle={`${progress !== 100 ? `${progress}%` : ''}`}
        classes={{
          actionIcon: classes.actionIcon,
        }}
        actionIcon={
          <IconButton
            size={'large'}
            onClick={onMore}
            className={classes.icon}
            aria-label={sanitizedName}
          >
            <Icon name={'dots-vertical'} />
          </IconButton>
        }
      />
    </ImageListItem>
  )
}

export default useMemoRef(AttachmentListTemplateGeneric, props => [props.attachment])
